@if (inLettura(); as lettura) {
    <!-- Testo integrale a tutto schermo: «Indietro» riporta all'elenco e restituisce il focus. -->
    <ion-toolbar color="primary">
      <ion-buttons slot="start">
        <ion-button (click)="chiudiLettura()">{{ 'documentiComune.gate.indietro' | transloco }}</ion-button>
      </ion-buttons>
      <ion-title id="modal-title">{{ 'documentiComune.gate.titolo' | transloco }}</ion-title>
    </ion-toolbar>

    <ion-content class="ion-padding">
      <div class="contenuto">
        <section class="documento">
          <h2 id="documenti-comune-lettura-titolo" tabindex="-1" class="documento-titolo" lang="it">{{ lettura.titolo }}</h2>
          <p class="accettazione">
            @if (eNuovo(lettura)) {
              @if (dataPubblicazione(lettura.pubblicato_at); as data) {
                {{ 'documentiComune.gate.nuovoIl' | transloco: { data } }}
              } @else {
                {{ 'documentiComune.gate.nuovo' | transloco }}
              }
            } @else {
              @if (dataPubblicazione(lettura.pubblicato_at); as data) {
                {{ 'documentiComune.gate.aggiornatoIl' | transloco: { data } }}
              } @else {
                {{ 'documentiComune.gate.aggiornato' | transloco }}
              }
            }
          </p>
          <app-termini-testo [testoHtml]="lettura.testo_html" [livelloMinimo]="3" lang="it" />
        </section>
        <ion-button expand="block" color="primary" fill="outline" class="azione-secondaria" (click)="chiudiLettura()">
          {{ 'documentiComune.gate.tornaAiDocumenti' | transloco }}
        </ion-button>
      </div>
    </ion-content>
} @else if (modalita === 'gate') {
    <ion-toolbar color="primary">
      <ion-title id="modal-title">{{ 'documentiComune.gate.titolo' | transloco }}</ion-title>
      <!-- «Esci» sempre visibile in testata (le modali del progetto tengono i comandi nella toolbar). -->
      <ion-buttons slot="end">
        <ion-button (click)="esci()">{{ 'documentiComune.gate.esci' | transloco }}</ion-button>
      </ion-buttons>
    </ion-toolbar>

    <ion-content class="ion-padding">
      <div class="contenuto">
        <p id="documenti-comune-intro" tabindex="-1" class="introduzione">
          @if (eAggiornamento()) {
            {{ 'documentiComune.gate.introduzioneAggiornamento' | transloco }}
          } @else {
            {{ 'documentiComune.gate.introduzione' | transloco }}
          }
        </p>

        @for (doc of documentiGate(); track doc.documento_id) {
          <section class="documento scheda">
            <h2 [id]="'doc-titolo-' + doc.documento_id" class="documento-titolo" lang="it">{{ doc.titolo }}</h2>

            <p class="accettazione">
              @if (doc.aggiornamento) {
                @if (dataPubblicazione(doc.pubblicato_at); as data) {
                  {{ 'documentiComune.gate.aggiornatoIl' | transloco: { data } }}
                } @else {
                  {{ 'documentiComune.gate.aggiornato' | transloco }}
                }
              } @else {
                @if (dataPubblicazione(doc.pubblicato_at); as data) {
                  {{ 'documentiComune.gate.nuovoIl' | transloco: { data } }}
                } @else {
                  {{ 'documentiComune.gate.nuovo' | transloco }}
                }
              }
            </p>
            @if (doc.aggiornamento) {
              <p class="avviso-aggiornamento">{{ 'documentiComune.gate.avvisoAggiornamento' | transloco }}</p>
            }

            <ion-button
              [id]="idLeggi(doc.documento_id)"
              expand="block"
              color="primary"
              fill="outline"
              class="azione-secondaria"
              [attr.aria-label]="'documentiComune.gate.leggiDocumentoNome' | transloco: { titolo: doc.titolo }"
              (click)="apriLettura(doc)">
              {{ 'documentiComune.gate.leggiDocumento' | transloco }}
            </ion-button>

            @if (obbligatorie(doc).length > 0) {
              <div class="spunte" role="group" [attr.aria-labelledby]="'doc-titolo-' + doc.documento_id">
                @for (spunta of obbligatorie(doc); track spunta.id) {
                  <ng-container *ngTemplateOutlet="casella; context: {spunta: spunta}" />
                }
              </div>
            }
          </section>
        }

        @if (facoltative().length > 0) {
          <section class="documento">
            <h2 id="documenti-comune-facoltativi" class="documento-titolo">{{ 'documentiComune.gate.consensiFacoltativi' | transloco }}</h2>
            <div class="spunte" role="group" aria-labelledby="documenti-comune-facoltativi">
              @for (voce of facoltative(); track voce.spunta.id) {
                <ng-container *ngTemplateOutlet="casella; context: {spunta: voce.spunta, doc: voce.doc}" />
              }
            </div>
          </section>
        }

        <!-- Regioni live sempre presenti nel DOM: solo così il contenuto che compare viene annunciato. -->
        <div role="alert" class="regione-errore">
          @if (errore(); as e) {
            <p class="errore">
              @switch (e) {
                @case ('obbligatorie') {
                  {{ 'documentiComune.gate.erroreObbligatorie' | transloco }}
                }
                @case ('versione') {
                  {{ 'documentiComune.gate.erroreVersione' | transloco }}
                }
                @default {
                  {{ 'documentiComune.gate.errore' | transloco }}
                }
              }
            </p>
          }
        </div>
        <div role="status" class="sr-only">{{ invioInCorso() ? ('documentiComune.caricamento' | transloco) : '' }}</div>

        <ion-button expand="block" color="primary" fill="solid" (click)="accetta()">
          @if (invioInCorso()) {
            <ion-spinner name="crescent" aria-hidden="true" slot="start"></ion-spinner>
          }
          {{ errore() === 'generico' ? ('documentiComune.gate.riprova' | transloco) : ('documentiComune.gate.accetta' | transloco) }}
        </ion-button>
      </div>
    </ion-content>

    <ng-template #casella let-spunta="spunta" let-doc="doc">
      <div class="spunta" [class.spunta-mancante]="mancanti().has(spunta.id)" [class.checked]="valoreSpunta(spunta.id)">
        <ion-checkbox
          [id]="idSpunta(spunta.id)"
          labelPlacement="end"
          justify="start"
          alignment="start"
          [checked]="valoreSpunta(spunta.id)"
          [class.ion-invalid]="mancanti().has(spunta.id)"
          [class.ion-touched]="mancanti().has(spunta.id)"
          [errorText]="'documentiComune.gate.spuntaMancante' | transloco"
          (ionChange)="impostaValore(spunta.id, $any($event.detail).checked)">
          <span class="spunta-testo" lang="it">{{ spunta.testo }}</span>
          <span class="spunta-stato">
            ({{ (spunta.obbligatoria ? 'documentiComune.gate.obbligatoria' : 'documentiComune.gate.facoltativa') | transloco }})
          </span>
          @if (doc && documentiGate().length > 1) {
            <span class="spunta-documento">{{ 'documentiComune.gate.riguarda' | transloco }} <span lang="it">{{ doc.titolo }}</span></span>
          }
        </ion-checkbox>
      </div>
    </ng-template>
} @else {
  <ion-toolbar color="primary">
    <ion-title id="modal-title">{{ 'documentiComune.consulta.titolo' | transloco }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="chiudi()">{{ 'documentiComune.consulta.chiudi' | transloco }}</ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-content class="ion-padding">
    <div class="contenuto">
      <div role="status" class="sr-only">{{ annuncioConsulta() }}</div>
      <div role="alert" class="regione-errore">
        @if (consultaStato() === 'errore') {
          <p class="errore">{{ 'documentiComune.consulta.errore' | transloco }}</p>
        }
      </div>
      @switch (consultaStato()) {
        @case ('caricamento') {
          <div class="caricamento">
            <ion-spinner name="crescent" aria-hidden="true"></ion-spinner>
            <span aria-hidden="true">{{ 'documentiComune.caricamento' | transloco }}</span>
          </div>
        }
        @case ('errore') {
          <ion-button expand="block" color="primary" fill="outline" class="azione-secondaria" (click)="caricaConsulta()">
            {{ 'documentiComune.consulta.riprova' | transloco }}
          </ion-button>
        }
        @case ('pronto') {
          @if (vigenti().length === 0) {
            <div class="vuoto">
              <ion-icon name="document-text-outline" aria-hidden="true"></ion-icon>
              <p class="vuoto-titolo">{{ 'documentiComune.consulta.vuoto' | transloco }}</p>
              <p class="vuoto-suggerimento">{{ 'documentiComune.consulta.vuotoSuggerimento' | transloco }}</p>
            </div>
          }
          @for (doc of vigenti(); track doc.documento_id) {
            <section class="documento scheda">
              <h2 [id]="'doc-titolo-' + doc.documento_id" class="documento-titolo" lang="it">{{ doc.titolo }}</h2>

              @if (doc.aggiornamento) {
                <!-- Nuova versione non ancora riaccettata: mia_accettazione vale per la versione precedente. -->
                <p class="accettazione">
                  @if (dataPubblicazione(doc.pubblicato_at); as data) {
                    {{ 'documentiComune.consulta.aggiornatoDaAccettare' | transloco: { data } }}
                  } @else {
                    {{ 'documentiComune.consulta.aggiornatoDaAccettareSenzaData' | transloco }}
                  }
                </p>
                <p class="avviso-aggiornamento">{{ 'documentiComune.gate.avvisoAggiornamento' | transloco }}</p>
              } @else {
                @if (doc.mia_accettazione; as acc) {
                  <p class="accettazione">
                    {{ 'documentiComune.consulta.accettatoIl' | transloco: { data: dataAccettazione(acc.accettato_at) } }}
                  </p>
                } @else {
                  <p class="accettazione">{{ 'documentiComune.consulta.nonAccettato' | transloco }}</p>
                }
                @if (dataPubblicazione(doc.pubblicato_at); as data) {
                  <p class="accettazione">{{ 'documentiComune.gate.aggiornatoIl' | transloco: { data } }}</p>
                }

                @if (doc.mia_accettazione && doc.spunte.length > 0) {
                  <ul class="spunte-lettura">
                    @for (spunta of doc.spunte; track spunta.id) {
                      <li>
                        @if (valoreAccettato(doc, spunta.id)) {
                          <ion-icon name="checkmark-circle-outline" class="scelta-si" aria-hidden="true"></ion-icon>
                        } @else {
                          <ion-icon name="close-circle-outline" class="scelta-no" aria-hidden="true"></ion-icon>
                        }
                        <span><span lang="it">{{ spunta.testo }}</span>:</span>
                        <strong>
                          {{ (valoreAccettato(doc, spunta.id) ? 'documentiComune.consulta.spuntaSi' : 'documentiComune.consulta.spuntaNo') | transloco }}
                        </strong>
                      </li>
                    }
                  </ul>
                }
              }

              <ion-button
                [id]="idLeggi(doc.documento_id)"
                expand="block"
                color="primary"
                fill="outline"
                class="azione-secondaria"
                [attr.aria-label]="'documentiComune.gate.leggiDocumentoNome' | transloco: { titolo: doc.titolo }"
                (click)="apriLettura(doc)">
                {{ 'documentiComune.gate.leggiDocumento' | transloco }}
              </ion-button>
            </section>
          }
        }
      }
    </div>
  </ion-content>
}
